<template>
    <div class="swiper_banner">
        <swiper ref="swiper" class="pc" :options="options">
            <template v-for="(item, index) in data">
                <swiper-slide :key="index">
                    <img :src="item" alt=""/>
                </swiper-slide>
            </template>
        </swiper>
        <swiper ref="mobileSwiper" class="mobile" :options="mobileOptions">
            <template v-for="(item, index) in mobileData">
                <swiper-slide :key="index">
                    <img :src="item" alt=""/>
                </swiper-slide>
            </template>
        </swiper>
        <div class="swiper-button-prev pc" slot="button-prev"></div>
        <div class="swiper-button-next pc" slot="button-next"></div>
        <div class="swiper-button-prev mobile" slot="button-prev"></div>
        <div class="swiper-button-next mobile" slot="button-next"></div>
    </div>
</template>

<script>
import { swiper, swiperSlide, directive, navigation } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
export default {
    name: "swiperBanner",
    props: [ 'data', 'mobileData' ],
    data() {
        return {
            options: {
                resistanceRatio: 0,
                navigation: {
                    prevEl: '.swiper_banner .swiper-button-prev.pc',
                    nextEl: '.swiper_banner .swiper-button-next.pc',
                },
                observer: true,
                observeParents: true,
            },
            mobileOptions: {
                resistanceRatio: 0,
                navigation: {
                    prevEl: '.swiper_banner .swiper-button-prev.mobile',
                    nextEl: '.swiper_banner .swiper-button-next.mobile',
                },
                observer: true,
                observeParents: true,
            },
        };
    },
    computed: {
        swiper() {
            return this.$refs.swiper.swiper
        },
        mobileSwiper() {
            return this.$refs.mobileSwiper.swiper
        },
    },
    components: {
        swiper,
        swiperSlide,
        
    },
    mounted() {},
    destroyed() {},
    watch: {},
    methods: {},
};
</script>

<style scoped lang="scss">
.swiper_banner{
    position: relative;
    .mobile{
        display: none;
    }
    .swiper-button-prev,
    .swiper-button-next{
        width: .24rem;
        height: .3rem;
        background: no-repeat 0/100%;
        margin-top: -0.15rem;
        &::after{
            display: none;
        }
        &.swiper-button-disabled{
            opacity: 0;
        }
    }
    .swiper-button-prev{
        left: -.75rem;
        background-image: url('~@/assets/images/icon_arrow_prev.svg');
    }
    .swiper-button-next{
        right: -.75rem;
        background-image: url('~@/assets/images/icon_arrow_next.svg');
    }
    @media only screen and (max-width: 1200px) {
        .pc{
            display: none;
        }
        .mobile{
            display: block;
        }
        .swiper-button-prev,
        .swiper-button-next{
            width: .64rem;
            height: .82rem;
            margin-top: 0;
            top: 3.75rem;
        }
        .swiper-button-prev{
            left: .35rem;
        }
        .swiper-button-next{
            right: .35rem;
        }
    }
}
</style>